<template>
  <div class="core-business-view">
    <section class="site-hero page-hero" :style="heroStyle">
      <div class="site-hero__inner">
        <!-- <span class="site-hero__eyebrow">Core Business</span> -->
        <h1>业务板块</h1>
        <p v-for="(paragraph, index) in pageIntro" :key="index">{{ paragraph }}</p>
      </div>
    </section>

    <section class="page-section overview-section">
      <div class="page-head">
        <div><h2>业务总览</h2></div>
      </div>
      <div class="page-shell">
        <capability-grid :items="capabilityCards" :show-code="false" :columns="3" />
      </div>
    </section>
  </div>
</template>

<script>
import CapabilityGrid from "../components/CapabilityGrid.vue";
import { getSitePage } from "@/api/website";

export default {
  name: "CoreBusinessView",
  components: {
    CapabilityGrid
  },
  data() {
    return {
      pageSettings: {
        bannerImage: "/assets/banner.png",
        intro: []
      },
      capabilityCards: []
    };
  },
  computed: {
    pageIntro() {
      return this.pageSettings.intro && this.pageSettings.intro.length ? this.pageSettings.intro : [];
    },
    heroStyle() {
      const image = this.pageSettings.bannerImage || "/assets/banner.png";
      return {
        "--page-banner-image": `url("${image}")`
      };
    }
  },
  created() {
    getSitePage("coreBusiness").then((res) => {
      const data = res.data || {};
      const pageSettings = data.pageSettings || {};
      this.pageSettings = pageSettings.coreBusiness || this.pageSettings;
      this.capabilityCards = data.capabilityCards || [];
    });
  }
};
</script>

<style lang="less" scoped>
.page-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    var(--page-banner-image) center / cover no-repeat;
}

.overview-section {
  background: var(--soft-blue);
  overflow: hidden;

  .page-head {
    max-width: 100%;
  }
}

.page-shell {
  //width: min(1280px, 100%);
  margin: 0 auto;
}

@media (max-width: 680px) {
  .overview-section {
    padding-left: 14px;
    padding-right: 14px;
  }

  .page-shell {
    width: 100%;
  }
}
</style>
